<input
    #file
    type="file"
    ngFileSelect
    [hidden]="true"
    [uploadInput]="uploadInput"
    (uploadOutput)="onUploadOutput($event)" />
